export default {
  customDashboard: {
    loading: 'Loading...',
    loadingData: 'Loading data...',
    selectedSensors: '{count} selected sensors',
    addNewChart: 'Add new chart',
    chartTitle: 'Chart title',
    selectSensors: 'Select sensors',
    selectSensorValidation: 'Select at least one sensor',
    chartType: 'Chart type',
    selectChartType: 'Select a chart type',
    startDate: 'Start date',
    endDate: 'End date',
    invalidDateRange: 'Invalid date range',
    sensorColors: 'Sensor colors',
    others: 'others',
    buttons: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      update: 'Update'
    },
    editChart: 'Edit chart',
    buttonColors: {
      green: '{sensorName} - Green',
      yellow: '{sensorName} - Yellow',
      red: '{sensorName} - Red'
    },
    selectDateRange: 'Select Date Range',
    quickFilters: 'Quick Filters',
    weeklyConsumption: 'Weekly Consumption',
    dataManager: 'Data Manager',
    lastRefilling: 'Last Refilling',
    dispenserLevel: 'Dispenser Level',
    time: 'Time',
    levelStatus: 'Level Status',
    fullEmptyDispenser: 'Full/Empty Dispenser',
    emptyHours: 'Empty Hours',
    consumptions: 'Consumptions',
    downloadChartData: 'Download Chart Data',
    downloadAllData: 'Download All Data',
    addNewWidget: 'Add new widget',
    widgetType: 'Widget type',
    chartTemplate: 'Chart template',
    comparisonLevel: 'Comparison level',
    entitiesToCompare: 'Entities to compare',
    period: 'Period',
    widgetTitle: 'Widget title',
    size: 'Size',
    filters: {
      title: 'Filters',
      clients: 'Clients',
      buildings: 'Buildings',
      floors: 'Floors',
      areas: 'Areas',
      dispenserType: 'Dispenser Type',
      productType: 'Product Type',
      selectAll: 'Select all',
      deselectAll: 'Deselect all'
    },
    sizes: {
      small: 'Small',
      medium: 'Medium',
      large: 'Large'
    },
    kpiType: 'KPI type',
    dataLevel: 'Data level',
    articleType: 'Article type',
    edit: 'Edit',
    delete: 'Delete',
    kpiTypes: {
      totalConsumption: {
        title: 'Total Paper Consumption',
        description: 'Total paper used in the selected time range'
      },
      averageDaily: {
        title: 'Average Daily Consumption',
        description: 'Average paper consumption per day'
      },
      mostUsedArticle: {
        title: 'Most Used Article',
        description: 'Most used paper type by percentage'
      },
      inactiveZones: {
        title: 'Inactive Zones',
        description: 'Number of areas with no activity during the selected time range'
      },
      estimatedCost: {
        title: 'Estimated Paper Cost',
        description: 'Estimated cost of paper used in the selected time range'
      },
      peakUsageDay: {
        title: 'Peak Usage Day',
        description: 'The day with the highest usage during the selected time range'
      }
    },
    chartTypes: {
      paperConsumption: {
        title: 'Paper Consumption',
        description: 'Compare total paper usage'
      },
      usageFrequency: {
        title: 'Usage Frequency',
        description: 'Compare how often areas are used'
      },
      paperCost: {
        title: 'Paper Cost',
        description: 'Compare estimated costs of paper usage'
      },
      alertEvents: {
        title: 'Alert Events',
        description: 'Compare how many alert events occurred'
      },
      consumptionVsFrequency: {
        title: 'Consumption vs Frequency',
        description: 'Compare daily usage frequency with paper consumption for a selected area'
      },
      sensorComparison: {
        title: 'Sensor Comparison',
        description: 'Compare historical data between selected sensors'
      },
      consumptionVsBathroom: {
        title: 'Consumption vs Bathroom Usage',
        description: 'Correlation between paper consumption and bathroom usage frequency'
      }
    },
    sensorCategories: {
      dispenser: 'Dispenser',
      doors: 'Doors'
    },
    sensorComparison: {
      title: 'Sensor Comparison',
      selectSensors: 'Select sensors to compare',
      selectCategory: 'Select category',
      noSensorsSelected: 'Select at least one sensor for comparison',
      loading: 'Loading sensor data...'
    }
  },
  sensor: {
    error: {
      loading: 'Error loading sensor details',
      updating: 'Error updating sensor',
      requiredFields: 'Please fill in all required fields',
      title: 'Error',
      emptyFields: 'The following fields are required: {fields}',
      duplicateDevEui: 'This Sensor ID already exists in the system',
      creation: 'Error creating sensor',
    },
    add: {
      title: 'SENSOR QUICK SETUP : Please fill the fields below'
    },
    fields: {
      sensorId: 'Sensor ID',
      dispenserName: 'Dispenser Name',
      dispenserBrand: 'Dispenser Brand',
      dispenserArticleCode: 'Dispenser Article Code',
      consumableBrand: 'Consumable Brand',
      consumableArticleCode: 'Consumable Article Code',
      client: 'Client',
      building: 'Building',
      floor: 'Floor',
      area: 'Area'
    },
    selectDispenser: 'Select Dispenser',
    notManagedYet: 'Not managed yet',
    emptyHours: 'Empty Hours',
    full: 'Full',
    empty: 'Empty'
  },
  login: {
    title: 'Login',
    button: 'Login',
    username: 'Username',
    password: 'Password',
    error: 'Incorrect username or password!',
    close: 'Close',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    resetPasswordInstructions: 'Please enter the email used during the registration',
    email: 'Email',
    resetRequested: 'Reset requested for:',
    enterNewPassword: 'Enter your new password in the fields below (make sure both password are the same in order to proceed)',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    passwordsDontMatch: 'The passwords don\'t match'
  },
  KEY001: 'Login',
  key006: 'Incorrect username or password!',
  key007: 'Close',
  validation: {
    required: 'This field is required',
    duplicateDevEui: 'This Sensor ID already exists'
  },
  building: {
    add: {
      title: 'CREATE A NEW BUILDING : Please fill the fields below'
    },
    fields: {
      name: 'Building name',
      address: 'Building address'
    },
    error: {
      creation: 'Error creating building'
    }
  },
  floor: {
    add: {
      title: 'CREATE A NEW FLOOR : Please fill the fields below'
    },
    fields: {
      name: 'Floor name',
      building: 'Building'
    },
    error: {
      creation: 'Error creating floor'
    }
  },
  area: {
    add: {
      title: 'CREATE A NEW AREA : Please fill the fields below'
    },
    fields: {
      name: 'Area name',
      building: 'Building',
      floor: 'Floor'
    },
    error: {
      creation: 'Error creating area'
    }
  },
  washroomFrequency: {
    selectSensor: 'Select one washroom sensor to continue',
    loading: 'Loading...',
    client: 'Client',
    building: 'Building',
    floor: 'Floor',
    area: 'Area',
    sensor: 'Sensor',
    back: 'BACK',
    ok: 'OK',
    quickFilters: 'Quick filters:',
    hours: '4 HOURS',
    day: '1 DAY',
    week: '1 WEEK',
    twoWeeks: '2 WEEKS',
    thirtyDays: '30 DAYS',
    selectDateRange: 'Select date range',
    cancel: 'Cancel',
    dataManager: 'DATA MANAGER',
    sensorName: 'Sensor name:',
    cleaningSchedule: 'CLEANING SCHEDULE',
    washroomUsageFrequency: 'WASHROOM USAGE FREQUENCY',
    lastCleaning: 'Last cleaning:',
    cleaningStatus: 'Cleaning status:',
    alertThreshold: 'Alert Threshold:',
    events: 'Events',
    cleaningRequired: 'Cleaning Required',
    mightNeedClean: 'Might need clean',
    doesntNeedClean: "Doesn't need clean"
  },
  manageSensors: {
    title: 'Manage Sensors',
    addNewSensor: 'Add new sensor',
    sensorDeleting: 'Sensor Deleting',
    deleteConfirm: 'Are you sure you want to delete "{name}"?',
    client: 'Client',
    building: 'Building',
    floor: 'Floor',
    area: 'Area',
    sensor: 'Sensor',
    clearFilter: 'Clear filter',
    filter: 'Filter',
    type: 'Type',
    fillLevel: 'Fill level',
    liveUsage: 'Live usage',
    cleaningLimit: 'Cleaning Threshold',
    name: 'Name',
    company: 'Company',
    battery: 'Battery',
    sensorId: 'Sensor ID',
    actions: 'Actions',
    editSensor: 'EDIT SENSOR',
    update: 'Update',
    noDataAvailable: 'No data available'
  },
  alerts: {
    title: 'Alerts',
    alertTime: 'ALERT TIME',
    solvedTime: 'SOLVED TIME',
    message: 'MESSAGE',
    markAsDone: 'Mark as done',
    triggerAt: 'Trigger at',
    resolvedAt: 'Resolved at',
    duration: 'Duration'
  },
  dashboard: {
    title: 'Dashboard',
    overview: 'Overview',
    statistics: 'Statistics',
    editWidget: 'Edit Widget',
    addWidget: 'Add Widget',
    widgetSize: 'Widget Size',
    size: 'Size',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    sizes: {
      small: 'Small',
      smallDesc: '1/4 width - Compact widgets',
      medium: 'Medium',
      mediumDesc: '1/2 width - Standard widgets',
      large: 'Large',
      largeDesc: 'Full width - Large widgets'
    }
  },
  alertsManagement: {
    pageTitle: 'Alerts Management',
    createRule: 'Create new rule',
    fillFields: 'Please, fill the fields below',
    title: 'Title',
    email: 'email (use ; to separate emails)',
    customMessage: 'Insert your custom message here:',
    alertValue: 'Alert Value (%) - n. of events',
    saveRule: 'Save rule',
    sensor: 'SENSOR',
    emailAddresses: 'EMAIL ADDRESSES',
    active: 'ACTIVE',
    phoneNumbers: 'PHONE NUMBERS',
    deleteConfirm: {
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete the rule "{title}"?',
      description: 'This action cannot be undone.'
    }
  },
  users: {
    title: 'Users',
    manageUser: 'Manage User',
    username: 'USERNAME',
    role: 'ROLE',
    active: 'ACTIVE'
  },
  buildings: {
    title: 'Buildings',
    name: 'Name',
    address: 'Address',
    sensors: 'Sensors'
  },
  smartDispenser: {
    selectSensor: 'Select one smart dispenser to continue',
    loading: 'Loading...',
    quickFilters: 'Quick filters:',
    hours: '4 HOURS',
    day: '1 DAY',
    threeDays: '3 DAYS',
    week: '1 WEEK',
    twoWeeks: '2 WEEKS',
    lastMonth: 'LAST MONTH',
    selectDateRange: 'Select date range',
    dataManager: 'DATA MANAGER',
    sensorName: 'Sensor name:',
    lastRefill: 'Last refilling:',
    consumption: 'Consumption:',
    binLevel: 'BIN LEVEL',
    dispenserLevel: 'DISPENSER LEVEL',
    dispenserAvailability: 'DISPENSER AVAILABILITY – % FULL vs EMPTY',
    dispenserDowntime: 'DISPENSER DOWNTIME – EMPTY HOURS / DAY',
    consumptions: 'CONSUMPTIONS',
    downloadChartData: 'Download chart data',
    downloadAllData: 'Download all sensor data',
    refillSchedule: 'REFILL SCHEDULE',
    levelStatus: 'Level status:',
    time: 'Time:'
  },
  smartBin: {
    selectSensor: 'Select one smart bin to continue',
    binLevel: 'BIN LEVEL',
    binFillLevel: 'BIN FILL LEVEL – LEVEL',
    averageFillingLevel: 'AVERAGE FILLING LEVEL',
    fillLevel: 'Fill Level'
  },
  airQuality: {
    selectSensor: 'Select one air quality sensor to continue',
    co2Level: 'CO2 LEVEL',
    temperature: 'TEMPERATURE',
    humidity: 'HUMIDITY',
    averageCo2: 'AVERAGE CO2 LEVEL'
  },
  sensorDetails: {
    sensorDetails: 'Sensor Details',
    deviceInfo: 'Device Information',
    location: 'Location',
    status: 'Status',
    lastUpdate: 'Last Update'
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    ok: 'OK',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    continue: 'Continue',
    search: 'Search',
    loading: 'Loading...',
    noDataAvailable: 'No data available',
    yes: 'Yes',
    no: 'No',
    saveChanges: 'Save Changes',
    others: 'others',
    days: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    }
  },
  dashboardsView: {
    selectOneOrMore: 'Select one or more sensor',
    selectOne: 'Select one sensor',
    selectBin: 'Select one or more Bin',
    selectDispenser: 'Select one or more dispenser',
    toiletPaper: 'Toilet Paper',
    rolls: 'N° rolls',
    foldedTowels: 'Folded Towels',
    sheets: 'N° sheets',
    cartons: 'N° Cartons',
    washroomFreq: 'Washroom Freq.',
    dailyAverage: 'Daily Average',
    binWasteLevel: 'BIN WASTE LEVEL',
    fullEmptyDispenser: 'FULL - EMPTY DISPENSER',
    washroomUsageFrequency: 'WASHROOM USAGE FREQUENCY',
    dispenserLevel1Floor: 'DISPENSER LEVEL - 1 FLOOR',
    paperConsumption: 'PAPER CONSUMPTION',
    emptyDispenserEvent: 'EMPTY DISPENSER EVENT'
  },
} 